module.exports = __webpack_public_path__ + "static/media/k-logo-1.73e993bf.svg";